<script lang="ts" setup>
import { computed, inject } from 'vue';
import usePortfolio from '../usePortfolio';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useIntervalCompute } from '@/helpers/useIntervalCompute';
import BaseValue from '@/components/BaseValue.vue';
import NetWorthCrypto from './NetWorthCrypto.vue';
import { useAppStore } from '@/store/app';
dayjs.extend(relativeTime);

const { portfolioInfo } = inject('portfolioData') as ReturnType<
  typeof usePortfolio
>;

const appStore = useAppStore();
</script>

<template>
  <div class="flex flex-col gap-1 relative w-full">
    <div class="flex flex-col p-4 sm:p-8 gap-2">
      <div class="flex flex-row items-center gap-2">
        <div
          class="w-5 h-5 rounded-full bg-primary flex items-center justify-center"
        >
          <v-icon icon="mdi-wallet" size="14"></v-icon>
        </div>
        <p>Net worth</p>
      </div>
      <div class="flex flex-col gap-1">
        <div class="flex flex-row items-center gap-2">
          <BaseValue
            class="text-4xl font-extrabold"
            :value="portfolioInfo.totalValue.value"
          ></BaseValue>
          <v-btn
            :icon="appStore.hideValues ? 'mdi-eye-off' : 'mdi-eye'"
            size="small"
            variant="text"
            class="text-disabled"
            @click="appStore.toggleHideValues"
          ></v-btn>
        </div>
        <NetWorthCrypto :totalValue="portfolioInfo.totalValue.value" />
      </div>
    </div>
  </div>
</template>
